import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from '../../core/Icon';
import PinIcon from './PinIcon';

var SideBarPins = function SideBarPins(_ref) {
  var classes = _ref.classes,
      options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      style = _ref.style,
      tooltips = _ref.tooltips;

  var needsCustomIcon = function needsCustomIcon(option) {
    return option.icon.startsWith('http://') || option.icon.startsWith('https://');
  };

  return React.createElement(List, {
    component: "nav",
    className: classes.content,
    style: style
  }, options.map(function (option) {
    return React.createElement(ListItem, {
      key: option.label,
      button: true,
      className: cx(classes.pinItem, _defineProperty({}, classes.active, option.value === value)),
      onClick: function onClick(e) {
        return onChange(option, e);
      }
    }, React.createElement(ListItemIcon, null, needsCustomIcon(option) ? tooltips ? React.createElement(PinIcon, {
      icon: option.icon,
      label: option.label
    }) : React.createElement(Tooltip, {
      title: option.label,
      disableFocusListener: true,
      placement: "right",
      PopperProps: {
        style: {
          pointerEvents: 'none'
        }
      }
    }, React.createElement("div", {
      className: classes.pinWrapper
    }, React.createElement(PinIcon, {
      icon: option.icon,
      label: option.label
    }))) : React.createElement(Icon, {
      label: tooltips ? undefined : option.label,
      tooltipPlacement: "right",
      type: option.icon,
      className: classes.icon
    })), React.createElement(ListItemText, {
      disableTypography: true,
      primary: option.label
    }));
  }));
};

var styles = function styles(theme) {
  return {
    content: {
      marginTop: theme.spacing(4)
    },
    pinItem: {
      height: 30
    },
    icon: {
      fontSize: '0.8125rem'
    },
    pinWrapper: {
      width: '13px'
    },
    active: {
      backgroundColor: lighten(theme.getStyle('Page.SideBar').backgroundColor, 0.4)
    },
    iconRoot: {
      textAlign: 'center',
      height: '100%'
    }
  };
};

export default withStyles(styles, {
  name: 'ECSideBarPins'
})(SideBarPins);